import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { handleRedacaoLogin } from '../../pages/LoginGoogle/LoginMiddleware';
import LoadingTransition from './LoadingTransition';

const OAuthCallback: React.FC = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const hash = window.location.hash.substring(1);
  //   const urlParams = new URLSearchParams(hash);
  //   const accessToken = urlParams.get('access_token');

  //   if (accessToken) {
  //     // Limpa o hash da URL antes de processar
  //     window.history.replaceState(null, '', window.location.pathname);
  //     handleRedacaoLogin(accessToken, dispatch);
  //   }
  // }, [dispatch]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const urlParams = new URLSearchParams(hash);
    const accessToken = urlParams.get('access_token');

    if (accessToken) {
      sessionStorage.setItem('auth_error_redirect', 'true'); // ← preventivo
      window.history.replaceState(null, '', window.location.pathname);
      handleRedacaoLogin(accessToken, dispatch);
    }
  }, [dispatch]);

  return <LoadingTransition />;
};

export default OAuthCallback;
